import React from 'react';
import { East } from '@mui/icons-material';

import './TimeSelectorRangeSeparator.scss';

interface TimeSelectorRangeSeparatorProps {
  className?: string;
}

export const TimeSelectorRangeSeparator: React.FC<TimeSelectorRangeSeparatorProps> = ({
  className = '',
}) => (
  <East
    className={`time-selector-range-separator ${className}`.trim()}
    fontSize="inherit"
    aria-hidden
  />
);
